import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {clinicColumns} from './columns/_columns'
import {ListClinic} from '../core/_models'
import {ClinicListLoading} from '../components/loading/CompanyListLoading'
import {ClinicListPagination} from '../components/pagination/CompanyListPagination'
import {KTCardBody} from '../../../../../../../_metronic/helpers'

const ClinicTable = () => {
  const clinic = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => clinic, [clinic])
  const columns = useMemo(() => clinicColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_companies'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<ListClinic>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<ListClinic>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ClinicListPagination />
      {isLoading && <ClinicListLoading />}
    </KTCardBody>
  )
}

export {ClinicTable}
